<template>
    <div>
        <div class="mb-3">{{ props.question.header[participant.language] }}</div>
        <div class="mb-4">{{ props.question.text[participant.language] }}</div>
        <div class="row mb-3">
            <div class="col-6">
                <select 
                    class="form-select" 
                    :name="props.question.variable"
                    @change="event => { response[props.question.variable] = event.target.value; saveResponse() }"
                >
                    <option value="" disabled selected>Select...</option>
                    <option v-for="option in props.question.select.options" 
                            :value="option.value"
                            :selected="response[props.question.variable] == option.value"
                            :key="option.value"
                    >
                        {{ option.label[participant.language] }}
                    </option>
                </select>
            </div>
        </div>
    </div>
</template>


<script setup>
    import { storeToRefs } from 'pinia'
    import { useSurveysStore } from '../../../stores/surveys'

    const { saveResponse } = useSurveysStore()
    const { participant, response } = storeToRefs(useSurveysStore())
    const props = defineProps(['question'])
</script>